import { getMessaging, getToken } from 'firebase/messaging';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from './firebase';

const VAPID_KEY = 'BMYiVNvrc7KaPBdZwvKWOange_PhXRdIHcAqhMfKaVvUwlZRKLOuaTHnRZTVejtRWIGNjMgIfQR2paaw8gbzJuc';

export const requestNotificationPermission = async (userId, collectionName) => {
  try {
    const permission = await Notification.requestPermission();

    if (permission === 'granted') {
      const messaging = getMessaging();

      // Register the service worker explicitly
      const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');

      const token = await getToken(messaging, {
        vapidKey: VAPID_KEY,
        serviceWorkerRegistration: registration
      });

      if (token) {
        // Save token to Firestore
        await updateDoc(doc(db, collectionName, userId), {
          fcmToken: token,
          notificationsEnabled: true,
          fcmTokenUpdatedAt: new Date()
        });

        return { success: true, token };
      }
    }

    return { success: false, error: 'Permission denied' };
  } catch (error) {
    console.error('Error getting FCM token:', error);
    return { success: false, error: error.message };
  }
};

export const syncFcmToken = async (userId, collectionName) => {
  try {
    if (Notification.permission === 'granted') {
      const messaging = getMessaging();
      const registration = await navigator.serviceWorker.ready;

      const token = await getToken(messaging, {
        vapidKey: VAPID_KEY,
        serviceWorkerRegistration: registration
      });

      if (token) {
        await updateDoc(doc(db, collectionName, userId), {
          fcmToken: token,
          fcmTokenUpdatedAt: new Date()
        });
        console.log('FCM token synced successfully');
        return true;
      }
    }
    return false;
  } catch (error) {
    console.error('Error syncing FCM token:', error);
    return false;
  }
};
